import { FormWizardController } from './form-wizard.controller';
import { FormWizardComponentProps } from './form-wizard.model';

const FormWizard = (props: FormWizardComponentProps): JSX.Element => {
  return <FormWizardController {...props} />;
};
export default FormWizard;
